import { signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { auth } from './config';

export const loginAdmin = async (email, password) => {
  const result = await signInWithEmailAndPassword(auth, email, password);
  return result.user;
};

export const logoutAdmin = async () => {
  await signOut(auth);
};
